
import { TipoDocumento, TipoDocumentoPorTipoPedido } from '@/models/sit-pedido/tipo-documento.enum';
import pedidoService from '@/services/sit-pedidos/pedido.service';
import UploadFile from './UploadFile.vue';

const SUBSTITUICAO_COOPERADO = 'SUBSTITUICAO_COOPERADO';
const MILITARY_DOCUMENT_KEYS = ['CARTEIRA_RESERVISTA', 'COMPROVANTE_SERVICO_MILITAR'];

const getSubstituicaoCooperadoDocumentos = () =>
  (
    TipoDocumentoPorTipoPedido.find(({ tipoPedido }) => tipoPedido === SUBSTITUICAO_COOPERADO)
      ?.documentos || []
  ).map(({ tipoDocumento }) => tipoDocumento);

const getTipoDocumentoLabel = (tipoDocumento: string) =>
  TipoDocumento[tipoDocumento as keyof typeof TipoDocumento] || tipoDocumento;

export default {
  name: 'StepDocumentacao',
  components: {
    UploadFile,
  },
  props: {
    idPedido: {
      type: Number,
      required: true,
    },
    sexo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      files: {} as Record<string, File | null>,
      selectedMilitaryDoc: null as string | null,
      erro: '',
      sucesso: '',
      finishSolicitacao: false,
      loading: false,
    };
  },
  computed: {
    isMasculino(): boolean {
      const s = (this.sexo || '').toUpperCase();
      return s === 'M' || s === 'MASCULINO';
    },
    militaryDocLabel(): string {
      return this.selectedMilitaryDoc ? getTipoDocumentoLabel(this.selectedMilitaryDoc) : '';
    },
    militaryDocOptions(): Array<{ key: string; label: string }> {
      return getSubstituicaoCooperadoDocumentos()
        .filter(tipoDocumento => MILITARY_DOCUMENT_KEYS.includes(tipoDocumento))
        .map(tipoDocumento => ({
          key: tipoDocumento,
          label: getTipoDocumentoLabel(tipoDocumento),
        }));
    },
    documentos(): Array<{ key: string; label: string }> {
      return getSubstituicaoCooperadoDocumentos()
        .filter(tipoDocumento => !MILITARY_DOCUMENT_KEYS.includes(tipoDocumento))
        .map(tipoDocumento => ({
          key: tipoDocumento,
          label: getTipoDocumentoLabel(tipoDocumento),
        }));
    },
  },
  watch: {
    documentos: {
      immediate: true,
      handler(docs: Array<{ key: string }>) {
        const newFiles: Record<string, File | null> = {};
        docs.forEach(doc => {
          newFiles[doc.key] = (this.files && this.files[doc.key]) || null;
        });
        this.files = newFiles;
      },
    },
    selectedMilitaryDoc(next: string | null, prev: string | null) {
      if (prev) {
        this.$set(this.files, prev, null);
      }
      if (next) {
        this.$set(this.files, next, null);
      }
    },
    files: {
      handler(newFiles: Record<string, File | null>) {
        const allDocsOk = this.documentos.every(doc => newFiles[doc.key] != null);
        const militaryOk = this.isMasculino
          ? !!this.selectedMilitaryDoc && newFiles[this.selectedMilitaryDoc] != null
          : true;
        if (allDocsOk && militaryOk) {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.finishSolicitacao = true;
          }, 5000);
        }
      },
      deep: true,
    },
  },
  methods: {
    async handleUpload() {
      this.erro = '';
      this.sucesso = '';
      const todosPreenchidos = Object.values(this.files).every(file => file !== null);
      if (todosPreenchidos) {
        this.erro = 'Preencha todos os documentos obrigatórios.';
        return;
      }
      let sucessoDocs = [];
      let erroDocs = [];
      const pedidoId = this.idPedido || 1233;
      if (!pedidoId) {
        this.erro = 'Pedido não encontrado.';
        return;
      }
      for (const doc of this.documentos) {
        const file = this.files[doc.key];
        if (!file) continue;
        try {
          await pedidoService.uploadDocumentoSubstituicaoCooperado(pedidoId, file);
          sucessoDocs.push(doc.label);
        } catch (e) {
          erroDocs.push(doc.label);
        }
      }
      if (erroDocs.length) {
        this.erro = `Erro ao enviar: ${erroDocs.join(', ')}`;
      }
      if (sucessoDocs.length) {
        this.sucesso = `Documentos enviados: ${sucessoDocs.join(', ')}`;
      }
    },
  },
};
